import React, { useEffect, useState } from "react";
import { Button, Typography, Space, Avatar, Form, Col } from "antd";
import { UserOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";

type Props = {}

const PreviewReviews = (props: any) => {
  const { review, index } = props

  const convertDate = (date: string) => {
    const inputDate: Date = new Date(date);

    // Step 2: Convert to the desired format
    const options: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
    const outputDateStr: string = inputDate.toLocaleDateString("en-US", options);
    
    // Adding the "th" suffix to the day, you can use a custom function:
    function addSuffixToDay(day: number): string {
      if (day >= 11 && day <= 13) {
        return day + "th";
      }
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }
    
    const dayWithSuffix: string = addSuffixToDay(inputDate.getDate());
    
    const outputDateStrWithSuffix: string = outputDateStr.replace(inputDate.getDate().toString(), dayWithSuffix);
  return outputDateStrWithSuffix
  }

  return (
    <>
      <Space
        direction="vertical"
        size="small"
        style={{ marginTop: "30px", width: '400px' }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography.Text type="secondary">
            <Avatar size="small" icon={<UserOutlined />} />
            <Typography.Text type="secondary" style={{ padding: "8px" }}>
              {review.firstName} {review.lastName}
            </Typography.Text>
          </Typography.Text>
          {/* <div style={{ justifyContent: "flex-end" }}>
                <Button
                  type="primary"
                  style={{ marginRight: "10px" }}
                  icon={<EditOutlined />}
                />
                <Button
                  danger
                  type="primary"
                  icon={<DeleteOutlined />}
                />
              </div> */}
        </div>
        <Typography.Text type="secondary">{convertDate(review.date)}</Typography.Text>
        <Typography.Text strong>{review.title}</Typography.Text>
        <Typography.Text>
          {
          // review.readmore ?
            decodeURIComponent(review.comments).replace(/%0A/g, "\n").split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))
            // : review.comments?.slice(0, 100)
            }
        </Typography.Text>
        {/* {
          review.comments?.length > 100 ?
            review.readmore
              ? <Button block className="read-btn" onClick={() => { props.handleRead() }}><UpOutlined /> Hide full review</Button>
              : <Button block className="read-btn" onClick={() => { props.handleRead() }}> <DownOutlined /> See full review</Button>
            : ''} */}
      </Space>

    </>
  )
}

export default PreviewReviews